var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuTile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "01_MenuTile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.2,
    y: 4.2,
    width: 8.4,
    height: 8.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.4,
    y: 4.2,
    width: 8.4,
    height: 8.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.2,
    y: 15.4,
    width: 8.4,
    height: 8.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.4,
    y: 15.4,
    width: 8.4,
    height: 8.4
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuTile);
export default __webpack_public_path__ + "static/media/menuTile.01bd3c43b71ce0700d41f063eca7c03d.svg";
export { ForwardRef as ReactComponent };